import { SERVER_METHODS, requestServer } from "./request";
import ApplicationError from "../utils/ApplicationError";

export const getCompanies = async () => {
  const path = "/companies";
  try {
    let res = await requestServer(SERVER_METHODS.GET, path);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new ApplicationError(res.status, await res.json());
    }
  } catch (error) {
    if (error instanceof ApplicationError) throw error;
    else throw JSON.stringify({ code: "INT", info: "OTHER ERROR" });
  }
};

export const getCompanySubsidiaries = async (companyId) => {
  const path = "/flokk_companylocation?parent_id=" + companyId;
  try {
    let res = await requestServer(SERVER_METHODS.GET, path);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new ApplicationError(res.status, await res.json());
    }
  } catch (error) {
    if (error instanceof ApplicationError) throw error;
    else throw JSON.stringify({ code: "INT", info: "OTHER ERROR" });
  }
};
export const getCompanyAddresses = async (companyId) => {
  const path = "/flokk_companylocation?parent_id=" + companyId;
  try {
    let res = await requestServer(SERVER_METHODS.GET, path);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new ApplicationError(res.status, await res.json());
    }
  } catch (error) {
    if (error instanceof ApplicationError) throw error;
    else throw JSON.stringify({ code: "INT", info: "OTHER ERROR" });
  }
};

export const updateCompany = async (company) => {
  const path = "/company/update";
  try {
    let res = await requestServer(SERVER_METHODS.POST, path, company);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new ApplicationError(res.status, await res.json());
    }
  } catch (error) {
    if (error instanceof ApplicationError) throw error;
    else throw JSON.stringify({ code: "INT", info: "OTHER ERROR" });
  }
};

export const updateCompanyAddress = async (address) => {
  const path = "/company/update_address";
  try {
    let res = await requestServer(SERVER_METHODS.POST, path, address);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new ApplicationError(res.status, await res.json());
    }
  } catch (error) {
    if (error instanceof ApplicationError) throw error;
    else throw JSON.stringify({ code: "INT", info: "OTHER ERROR" });
  }
};

export const updateCompanySubsidiary = async (subsidiary) => {
  const path = "/company/update_subsidiary";
  try {
    let res = await requestServer(SERVER_METHODS.POST, path, subsidiary);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new ApplicationError(res.status, await res.json());
    }
  } catch (error) {
    if (error instanceof ApplicationError) throw error;
    else throw JSON.stringify({ code: "INT", info: "OTHER ERROR" });
  }
};

export const updateCompanyContract = async (contract) => {
  const path = "/company/update_contract";
  try {
    let res = await requestServer(SERVER_METHODS.POST, path, contract);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new ApplicationError(res.status, await res.json());
    }
  } catch (error) {
    if (error instanceof ApplicationError) throw error;
    else throw JSON.stringify({ code: "INT", info: "OTHER ERROR" });
  }
};

export const updateCompanyBrand = async (companyBrandObj) => {
  const path = "/company/update_brand";
  try {
    let res = await requestServer(SERVER_METHODS.POST, path, companyBrandObj);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new ApplicationError(res.status, await res.json());
    }
  } catch (error) {
    if (error instanceof ApplicationError) throw error;
    else throw JSON.stringify({ code: "INT", info: "OTHER ERROR" });
  }
};

export const disableCompanyBrand = async (companyBrandObj) => {
  const path = "/company/disable_brand";
  try {
    let res = await requestServer(SERVER_METHODS.POST, path, companyBrandObj);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new ApplicationError(res.status, await res.json());
    }
  } catch (error) {
    if (error instanceof ApplicationError) throw error;
    else throw JSON.stringify({ code: "INT", info: "OTHER ERROR" });
  }
};
